<div class="mms-worksheet p-20 m-0-auto">
    <div style="display: flex; justify-content: flex-end;">
        <button nzTooltipPlacement="bottom" nz-button nz-tooltip nz-button (click)="reevaluate_uwNote()"><i nz-icon nzType="reload"></i>Reload</button>
        <div style="width: 5px;"></div>
        <button nzTooltipPlacement="bottom" nz-button nz-tooltip nz-button (click)="download_uwNote()"><i nz-icon nzType="download"></i>Download</button>
    </div>
    <div id="uwWorksheetSection">
    <!-- Header -->
    <ng-container *ngIf="riskSummarizationLoader">
        <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
          <p><i nz-icon nzType="loading" theme="outline"></i>&nbsp; Loading...</p>
        </div>
      </ng-container>

    <ng-container *ngIf="riskSummarizationContent && refreshModal; else showNoRiskSummaryContent">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <div>
                <div *ngIf="overallRisk">
                    <span class="heading" style="font-weight: 700; font-size: 1.5em;">Overall Proposal Risk : </span>
                    <span
                        [ngClass]="{'font-green' : overallRisk == 'Low', 'font-orange' : overallRisk == 'Medium', 'font-red' : overallRisk == 'High'}"
                        style="font-weight: 700; font-size: 1.5em;">{{overallRisk}}</span>
                </div>
                <app-markdown id="pdfContent" [textContent]="riskSummarizationContent" ></app-markdown>
            </div>
        </div>
    </ng-container>
    <ng-template #showNoRiskSummaryContent>
        <ng-container *ngIf="!riskSummarizationLoader">
            <nz-result nzStatus="500" nzTitle="Loading...">
                <!-- nzSubTitle="Please contact administrator if the issue persists." -->
                <!-- <div nz-result-extra> <button nz-button nzType="primary">Back Home</button> </div> -->
            </nz-result>
        </ng-container>
        <!-- has context menu -->
    </ng-template>
    <!-- Updated Risk Summarization -->
    <div *ngIf="showRiskSummaryTable">
        <ng-container *ngIf="riskSummarizationResponse; else showNoRiskSummary">
            <div class="grid grid-gap-10">
                <div *ngIf="riskSummarizationResponse.overall_risk">
                    <span class="heading" style="font-weight: 700; font-size: 1.5em;">Overall Proposal Risk : </span>
                    <span [ngClass]="{'font-green' : riskSummarizationResponse.overall_risk == 'Low', 'font-orange' : riskSummarizationResponse.overall_risk == 'Medium', 'font-red' : riskSummarizationResponse.overall_risk == 'High'}" style="font-weight: 700; font-size: 1.5em;">{{riskSummarizationResponse.overall_risk}}</span>
                </div>
                <div *ngIf="riskSummarizationResponse.overall_recommendation">
                    <span class="heading" style="font-weight: 600;">Overall Proposal Recommendation : </span>
                    <span *ngIf="userDetails && userDetails.recommendation;">{{userDetails.recommendation}}</span>
                </div>
                <!-- <span *ngIf="riskSummarizationResponse.overall_recommendation">Overall Proposal Recommendation : {{riskSummarizationResponse.overall_recommendation}}</span> -->
            </div>
            <div>
                <ng-container>
                    <!-- <i nz-icon nzType="issues-close"></i> Criteria wise risk summarization -->
                    <div class="heading-tab panel-custom-unified-collapse-heading m-b-20 m-t-20">
                        <h3 class="heading"><i nz-icon nzType="issues-close"></i> Criteria wise risk summarization</h3>
                    </div>
                </ng-container>
                <nz-table #riskSummarization [nzData]="riskSummarizationResponse.criteria_wise_risk_list" [nzShowPagination]="false">
                    <thead class="table-header">
                    <tr>
                        <th class="">Criteria</th>
                        <th class="">Risk Level</th>
                        <th class="">Recommendation</th>
                    </tr>
                    </thead>
                    <tbody class="">
                    <tr class="table-row" *ngFor="let criteria of riskSummarization.data">
                        <td class="">{{ criteria.criteria_value}}</td>
                        <td [ngClass]="{'font-green' : criteria.criteria_risk_level == 'Low', 'font-orange' : criteria.criteria_risk_level == 'Medium', 'font-red' : criteria.criteria_risk_level == 'High'}">{{ criteria.criteria_risk_level}}</td>
                        <td class="">{{ criteria.criteria_risk_description}}</td>
                    </tr>
                    </tbody>
                </nz-table>
            </div>
        </ng-container>
        <ng-template #showNoRiskSummary>
            <ng-container *ngIf="!riskSummarizationLoader">
            <nz-result nzStatus="500" nzTitle="Oops! There seems to be some problem with extraction." nzSubTitle="Please contact administrator if the issue persists.">
                <!-- <div nz-result-extra> <button nz-button nzType="primary">Back Home</button> </div> -->
            </nz-result>
        </ng-container>
            <!-- has context menu -->
        </ng-template>
    </div>
    </div>
</div>